import SpecialEventEdit from "./-modules/SpecialEventEdit";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/opr/specialEventConfiguration/edit/$id")({
  staticData: {
    menuLabel: "编辑专场",
    menuHighlightPath: "/opr/specialEventConfiguration",
  },
  component: SpecialEventEdit,
});
